import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { registerLicense } from '@syncfusion/ej2-base';

if (environment.production) {
  enableProdMode();
}

// Registering Syncfusion license key
registerLicense('ORg4AjUWIQA/Gnt2U1hhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hT35Vd0xiWn9dcnJdRGNfWkZw');
// Ngo9BigBOggjHTQxAR8/V1NCaF1cWWhAYVF0WmFZfVpgdVRMZFpbRHJPMyBoS35RckVrW3xfcXFdRGJVU0x2

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
